import React, { useState } from 'react';
import './FilterButtons.css';

const FilterButtons = () => {
  const [activeFilter, setActiveFilter] = useState('All Watches');

  const filters = [
    { name: 'All Watches', icon: '⌚' },
    { name: 'Smart Watches', icon: '📱' },
    { name: 'Luxury Watches', icon: '💎' },
    { name: 'Sports Watches', icon: '🏃' },
    { name: 'Casual Watches', icon: '🕰️' }
  ];

  return (
    <div className="filter-buttons">
      <div className="filter-buttons-container">
        <div className="filters-section">
          <div className="filters-icon">⚙️</div>
          <span className="filters-label">Filters</span>
        </div>
        
        <div className="filter-options">
          {filters.map((filter) => (
            <button
              key={filter.name}
              className={`filter-button ${activeFilter === filter.name ? 'active' : ''}`}
              onClick={() => setActiveFilter(filter.name)}
            >
              {filter.icon} {filter.name}
            </button>
          ))}
        </div>

        <div className="upload-date-section">
          <span className="upload-date-label">Sort by</span>
          <div className="upload-date-dropdown">
            <span>Newest</span>
            <span className="dropdown-arrow">▼</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterButtons;
